import { InputNumber as AntdInputNumber } from "antd"
import { t } from "i18next"

const InputNumber = props => {
  return <AntdInputNumber controls={false} placeholder={t("Please add numeric value")} {...props}></AntdInputNumber>
}

export default InputNumber
